import { clearError } from "../../../../error";
import { undoPriceRange } from "../../priceRange/thunks";
import { clearNewSearch, setNewSearch } from "../../store/actionCreators";

const undoSearch = () => (dispatch) => {
  dispatch(clearNewSearch());
  dispatch(clearError());
  dispatch(undoPriceRange());
  dispatch(setNewSearch());
};

export default undoSearch;
